import { render, staticRenderFns } from "./SliderSmall.vue?vue&type=template&id=52c0f9a0&"
import script from "./SliderSmall.vue?vue&type=script&lang=js&"
export * from "./SliderSmall.vue?vue&type=script&lang=js&"
import style0 from "./SliderSmall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports